import LazyDisp from "../class/lazydisp";

const [w, d] = [window, document];

export default class company {
  constructor () {
  }
  init(){
    Promise.all([w.load['loadHtml']]).then(() => this.onLoadHtml());
    return this;
  }

  getNav(){
    $.get('/src/html/company-nav.html').then( html => {
      $('.rwd002-breadcrumbs').before( html );
      $('[data-plugin=currentMenu]').currentMenu({mode:0,default:999});
    });
  }

  onLoadHtml (){
    // LazyDisp開始
    new LazyDisp('[data-lazydisp]');
  }
}